import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContactPersonForm from "../../components/contactpersons/ContactPersonForm";
import { createContactPerson } from "../../api/contactPersons";
import { CreateContactPersonDto } from "../../types/companyTypes";

const CreateContactPerson: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const companyIdParam = searchParams.get("companyId");
  // Supports deep-linking from a company page where the company is already known.
  const initialCompanyId = companyIdParam ? Number(companyIdParam) : null;

  const handleSubmit = async (data: CreateContactPersonDto) => {
    const response = await createContactPerson(data);
    navigate(`/ansprechpersonen/${response.data.contactPersonId}`);
  };

  return (
    <ContactPersonForm
      title="Neue Ansprechperson"
      submitLabel="Erstellen"
      cancelHref="/ansprechpersonen"
      dialogIntro="Folgende Ansprechperson wird erstellt:"
      dialogActorLabel="Erstellt von"
      initialCompanyId={initialCompanyId}
      onSubmit={handleSubmit}
    />
  );
};

export default CreateContactPerson;
